import { render, staticRenderFns } from "./participantAudioSetting.vue?vue&type=template&id=5a0234ba&scoped=true"
import script from "./participantAudioSetting.vue?vue&type=script&lang=js"
export * from "./participantAudioSetting.vue?vue&type=script&lang=js"
import style0 from "./participantAudioSetting.vue?vue&type=style&index=0&id=5a0234ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0234ba",
  null
  
)

export default component.exports